import React from 'react';
import { Container } from '@plone/components';
import FileViewer from 'cmuberlandia-portal/components/FileViewer/FileViewer';
import type { File } from 'cmuberlandia-portal/types/content';

interface FileViewProps {
  content: File;
}

const FileView = ({ content }: FileViewProps) => {
  return (
    <Container id="page-document" className="view-wrapper fileitem-view">
      <h1 className="documentFirstHeading">{content.title}</h1>
      {content.description && (
        <p className="documentDescription">{content.description}</p>
      )}
      {content.file && <FileViewer file={content.file} />}
    </Container>
  );
};

export default FileView;
